<template>
  <div class="pb-5">
    <!-- Back button and logo container -->
    <div class="relative flex items-center pt-14 px-5">
      <!-- Back arrow (left side) -->
      <img
          src="@/assets/back_arrow.png" alt="Back arrow"
           @click="onBack"
           class="w-6 h-6 cursor-pointer" :hidden="loader === true && page ==='Summary'">


      <!-- Centered logo -->
      <div class="absolute left-1/2 transform -translate-x-1/2">
        <img src="@/assets/tfp_logo.svg" alt="TFP logo" class="h-10 w-auto">
      </div>
    </div>

    <h1 class="font-bold text-center responsive-body-large pt-10 pb-3 overflow-hidden">
      {{ t('returnRequest.title') }}
    </h1>
    <h3 class="text-center text-[#7C7C7C] responsive-body-medium overflow-hidden">
      {{ t('returnRequest.order') }} #{{ order }}
    </h3>
  </div>
</template>

<script setup>
  import { useOrderDataStore } from "@/stores/orderDataStore";
  import { useI18n } from "vue-i18n";
  import {computed, defineProps} from "vue";

  
  // Props
  defineProps({
  onBack: Function,
  loader: Boolean,
  page: String
});

  // Pinia store
  const orderDataStore = useOrderDataStore();

  // Computed order
  const order = computed(() => orderDataStore.order);

  // i18n
  const { t } = useI18n();
</script>

<style scoped>
</style>
